import { render, staticRenderFns } from "./OrderAdmin.vue?vue&type=template&id=528d2014&"
import script from "./OrderAdmin.vue?vue&type=script&lang=js&"
export * from "./OrderAdmin.vue?vue&type=script&lang=js&"
import style0 from "./OrderAdmin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports